// @ts-ignore
import HfReactHelper from '../../../hellosign/components/hf-react-helper';

export default function editorActions(
  csrfToken: string,
  csrfTokenAttachmentDelete: string,
  preLoadedTsmGroupKey: string,
) {

  async function loadData(cachedParamsToken: string) {
    // Fetch the data from the server
    const url = `/editor/getData?cached_params_token=${cachedParamsToken}`;
    const response = await fetch(HfReactHelper.attachSessionInfoToUrl(url), {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    const data = await response.json();

    return data.data;
  }

  async function loadAutoSuggestionData() {

    const autocompleteResponse = await fetch(HfReactHelper.attachSessionInfoToUrl('/editor/asyncAutocomplete'), {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    return autocompleteResponse.json();
  }

  async function keepSessionAlive() {
    // keep session alive
    await fetch(HfReactHelper.attachSessionInfoToUrl('/account/keepSessionAlive'), {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
  }

  async function deleteDocument(snapshotGuid: string) {
    if (snapshotGuid) {
      const formData = new FormData();
      formData.append('snapshot_guid', snapshotGuid);
      formData.append('csrf_token', csrfTokenAttachmentDelete);
      formData.append('preloaded_tsm_group_key', preLoadedTsmGroupKey);

      const response = await fetch(HfReactHelper.attachSessionInfoToUrl('/attachment/delete'), {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      if (result.error) {
        throw new Error(result.error);
      }
    }
  }

  async function saveData(data: any) {
    data.csrf_token = csrfToken;

    const response = await fetch(HfReactHelper.attachSessionInfoToUrl('/editor/saveData'), {
      credentials: 'same-origin',
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return response.json();
  }

  return {
    loadData,
    loadAutoSuggestionData,
    keepSessionAlive,
    deleteDocument,
    saveData,
  };
}
